module.exports = __webpack_public_path__ + "am.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/am.svg
// module id = 415
// module chunks = 0